import { render, staticRenderFns } from "./NavH5.vue?vue&type=template&id=45ac4c76&scoped=true"
import script from "./NavH5.vue?vue&type=script&lang=js"
export * from "./NavH5.vue?vue&type=script&lang=js"
import style0 from "./NavH5.vue?vue&type=style&index=0&id=45ac4c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ac4c76",
  null
  
)

export default component.exports